// import React, { useState } from "react";
// import { API } from "../config/api";
// import { post } from "../lib/http";

// export default function ContactPage() {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     message: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [isLoading, setIsLoading] = useState(false);
//   const [status, setStatus] = useState({ type: "", message: "" });

//   const onChange = (e) => {
//     const { name, value } = e.target;
//     setForm((f) => ({ ...f, [name]: value }));
//     // clear error on change
//     setErrors((prev) => ({ ...prev, [name]: "" }));
//     setStatus({ type: "", message: "" });
//   };

//   const validate = () => {
//     const errs = {};
//     if (!form.name.trim()) errs.name = "Please enter your name.";
//     if (!form.email.trim()) {
//       errs.email = "Please enter your email.";
//     } else {
//       const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email);
//       if (!emailOk) errs.email = "Please enter a valid email.";
//     }
//     if (form.phone.trim()) {
//       const phoneOk = /^[+\d][\d\s\-()]{6,18}$/.test(form.phone.trim());
//       if (!phoneOk) errs.phone = "Please enter a valid phone (or leave blank).";
//     }
//     if (!form.message.trim()) errs.message = "Please add a short message.";
//     setErrors(errs);
//     return Object.keys(errs).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     setIsLoading(true);
//     setStatus({ type: "", message: "" });

//     try {
//       const payload = {
//         name: form.name.trim(),
//         // email: form.email.trim(),
//         // phone: form.phone.trim() || null,
//         message: form.message.trim(),
//         source: "website-contact",
//         submittedAt: new Date().toISOString(),
//       };

//       // Adjust this call if your post helper has a different signature
//       const res = await post(`${API.review.contact}`, payload, {
//         headers: { "Content-Type": "application/json" },
//       });

//       // Try to normalize success/message
//       const success =
//         (res && (res.success === true || res.status === "ok")) || false;
//       const serverMsg =
//         (res && (res.message || res.msg || res.data?.message)) ||
//         "Thanks! We’ll get back to you soon.";

//       if (success) {
//         setStatus({ type: "success", message: serverMsg });
//         setForm({ name: "", email: "", phone: "", message: "" });
//       } else {
//         setStatus({
//           type: "error",
//           message:
//             serverMsg ||
//             "We couldn’t submit your message right now. Please try again.",
//         });
//       }
//     } catch (err) {
//       console.error("Contact submit error:", err);
//       setStatus({
//         type: "error",
//         message: "❌ Failed to submit. Please check your internet and try again.",
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <main className="min-h-[70vh] bg-white">
//       <section className="max-w-6xl mx-auto px-4 py-10 grid lg:grid-cols-2 gap-8">
//         {/* Left: Details */}
//         <div>
//           <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">
//             Contact Us
//           </h1>
//           <p className="mt-2 text-slate-600">We’d love to hear about your next show.</p>

//           <div className="mt-6 rounded-2xl border p-5">
//             <h2 className="text-lg font-semibold text-slate-900">
//               Razzle Dazzle Entertainment
//             </h2>

//             <div className="mt-4 space-y-3 text-slate-700">
//               <p>
//                 <b>Address:</b> 3rd Floor, Malhar Mall, Indore
//               </p>
//               <p>
//                 <b>Email:</b>{" "}
//                 <a
//                   className="text-amber-600 hover:underline"
//                   href="mailto:business.razzledazzle@gmail.com"
//                 >
//                   business.razzledazzle@gmail.com
//                 </a>
//               </p>
//               <p>
//                 <b>Instagram:</b>{" "}
//                 <a
//                   className="text-amber-600 hover:underline"
//                   href="https://www.instagram.com/showtimebroo?igsh=MWhtODllcHRuN3hrbw=="
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   @showtimebro
//                 </a>
//               </p>
//               <p>
//                 <b>Website:</b>{" "}
//                 <a
//                   className="text-amber-600 hover:underline"
//                   href="https://showtimebro.com"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   https://showtimebro.com
//                 </a>
//               </p>
//                <p>
//                 <b>Mobile:</b>{" "}
//                 <a
//                   className="text-amber-600 hover:underline"
//                   href="https://showtimebro.com"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   +91 9179981316               
//                    </a>
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Right: Simple form */}
//         <form onSubmit={handleSubmit} className="rounded-2xl border p-5 bg-slate-50">
//           <h2 className="text-lg font-semibold text-slate-900">Send a message</h2>

//           {status.message ? (
//             <div
//               className={`mt-3 rounded-xl px-4 py-3 text-sm ${
//                 status.type === "success"
//                   ? "bg-green-50 text-green-800 border border-green-200"
//                   : "bg-red-50 text-red-800 border border-red-200"
//               }`}
//             >
//               {status.message}
//             </div>
//           ) : null}

//           <div className="mt-4 grid grid-cols-1 gap-4">
//             <div>
//               <input
//                 className={`w-full rounded-xl border px-4 py-3 ${
//                   errors.name ? "border-red-400" : "border-slate-200"
//                 }`}
//                 placeholder="Your Name"
//                 name="name"
//                 value={form.name}
//                 onChange={onChange}
//               />
//               {errors.name && (
//                 <p className="mt-1 text-xs text-red-600">{errors.name}</p>
//               )}
//             </div>

//             <div>
//               <input
//                 className={`w-full rounded-xl border px-4 py-3 ${
//                   errors.email ? "border-red-400" : "border-slate-200"
//                 }`}
//                 placeholder="Email"
//                 type="email"
//                 name="email"
//                 value={form.email}
//                 onChange={onChange}
//               />
//               {errors.email && (
//                 <p className="mt-1 text-xs text-red-600">{errors.email}</p>
//               )}
//             </div>

//             <div>
//               <input
//                 className={`w-full rounded-xl border px-4 py-3 ${
//                   errors.phone ? "border-red-400" : "border-slate-200"
//                 }`}
//                 placeholder="Phone (optional)"
//                 name="phone"
//                 value={form.phone}
//                 onChange={onChange}
//               />
//               {errors.phone && (
//                 <p className="mt-1 text-xs text-red-600">{errors.phone}</p>
//               )}
//             </div>

//             <div>
//               <textarea
//                 className={`w-full rounded-xl border px-4 py-3 ${
//                   errors.message ? "border-red-400" : "border-slate-200"
//                 }`}
//                 rows={5}
//                 placeholder="Tell us about your event…"
//                 name="message"
//                 value={form.message}
//                 onChange={onChange}
//               />
//               {errors.message && (
//                 <p className="mt-1 text-xs text-red-600">{errors.message}</p>
//               )}
//             </div>
//           </div>

//           <button
//             type="submit"
//             disabled={isLoading}
//             className={`mt-4 w-full rounded-xl font-semibold px-4 py-3 ${
//               isLoading
//                 ? "bg-amber-300 cursor-not-allowed text-slate-800"
//                 : "bg-amber-500 hover:bg-amber-400 text-slate-900"
//             }`}
//           >
//             {isLoading ? "Submitting..." : "Submit"}
//           </button>

//           {/* Small privacy note (optional) */}
//           <p className="mt-3 text-xs text-slate-500">
//             By submitting, you agree to be contacted about your inquiry.
//           </p>
//         </form>
//       </section>
//     </main>
//   );
// }

// FILE: src/pages/ContactPage.jsx
// A polished, accessible Contact page with form validation and clear UX.
import React, { useState } from "react";
import { API } from "../config/api";
import { post } from "../lib/http";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null); // { type: 'success' | 'error', text: string }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const validate = () => {
    if (!form.name.trim()) return "Please enter your name.";
    if (!form.email.trim()) return "Please enter your email.";
    // simple email regex
    const emailRe = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    if (!emailRe.test(form.email)) return "Please enter a valid email address.";
    if (!form.message.trim()) return "Please enter a message.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    const err = validate();
    if (err) {
      setStatus({ type: "error", text: err });
      return;
    }

    setSubmitting(true);

    try {
      const payload = {
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        message: form.message.trim(),
      };

      const res = await post(API.review.contact, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (res?.success === false) {
        throw new Error(res?.message || "Failed to send message.");
      }

      setStatus({ type: "success", text: "Thank you — your message has been received. We'll get back to you shortly." });
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      setStatus({
        type: "error",
        text: error?.message || "Something went wrong. Please try again later.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="min-h-screen bg-slate-50">
      <div className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-6xl px-4 py-8">
          <h1 className="text-2xl font-semibold text-slate-900">Contact Us</h1>
          <p className="mt-1 text-sm text-slate-600">Have questions? We're here to help — reach out anytime.</p>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4 py-10 grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Contact details */}
        <section className="bg-white rounded-lg p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-900">Get in touch</h2>
          <p className="mt-3 text-slate-700">For support or business enquiries, contact us at:</p>

          <ul className="mt-4 space-y-3 text-slate-700">
            <li>
              <strong>Email:</strong>{" "}
              <a className="text-amber-600 underline" href="mailto:info@showtimebro.com">info@showtimebro.com</a>
            </li>
            <li>
              <strong>Phone / WhatsApp:</strong> <a href="tel:+919479839747" className="underline">+91 94798 39747</a>
            </li>
            <li>
              <strong>Office hours:</strong> Mon — Fri, 10:00 — 18:00 IST
            </li>
          </ul>

          <div className="mt-6">
            <h3 className="text-sm font-medium text-slate-900">Follow us</h3>
            <div className="mt-2 flex items-center gap-3">
              <a aria-label="ShowTimeBro on Instagram" href="https://www.instagram.com/showtimebro_official?igsh=MnlmeG5yMm81bTJw" target="_blank" rel="noreferrer" className="text-slate-600 underline text-sm">Instagram</a>
              <a aria-label="ShowTimeBro on Facebook" href="#" className="text-slate-600 underline text-sm">Facebook</a>
              <a aria-label="ShowTimeBro on X" href="#" className="text-slate-600 underline text-sm">X</a>
            </div>
          </div>

          <div className="mt-6 text-xs text-slate-500">
            <p>For urgent issues related to bookings, please include booking ID and event details in your message.</p>
          </div>
        </section>

        {/* Contact form */}
        <section className="bg-white rounded-lg p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-900">Send us a message</h2>

          <form onSubmit={handleSubmit} className="mt-4 space-y-4" aria-label="Contact form">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-slate-700">Name</label>
              <input
                id="name"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                disabled={submitting}
                className="mt-1 block w-full rounded-md border border-slate-300 bg-white px-3 py-2 shadow-sm focus:outline-none focus:ring-1 focus:ring-amber-500"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-slate-700">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                required
                disabled={submitting}
                className="mt-1 block w-full rounded-md border border-slate-300 bg-white px-3 py-2 shadow-sm focus:outline-none focus:ring-1 focus:ring-amber-500"
              />
            </div>

            <div>
              <label htmlFor="phone" className="block text-sm font-medium text-slate-700">Phone (optional)</label>
              <input
                id="phone"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                disabled={submitting}
                className="mt-1 block w-full rounded-md border border-slate-300 bg-white px-3 py-2 shadow-sm focus:outline-none focus:ring-1 focus:ring-amber-500"
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-slate-700">Message</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                disabled={submitting}
                rows={6}
                className="mt-1 block w-full rounded-md border border-slate-300 bg-white px-3 py-2 shadow-sm focus:outline-none focus:ring-1 focus:ring-amber-500"
              />
            </div>

            <div className="flex items-center gap-4">
              <button
                type="submit"
                disabled={submitting}
                className="inline-flex items-center rounded-md bg-amber-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-amber-700 disabled:opacity-60"
              >
                {submitting ? "Sending..." : "Send Message"}
              </button>

              <button
                type="button"
                onClick={() => { setForm({ name: "", email: "", phone: "", message: "" }); setStatus(null); }}
                disabled={submitting}
                className="inline-flex items-center rounded-md border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-60"
              >
                Reset
              </button>
            </div>

            {status && (
              <p
                role="status"
                className={`mt-2 text-sm ${status.type === "success" ? "text-green-600" : "text-red-600"}`}
              >
                {status.text}
              </p>
            )}

          </form>
        </section>

        {/* Optional: map or address block could go below in full-width */}
        <div className="md:col-span-2">
          <section className="bg-white rounded-lg p-6 shadow-sm mt-2">
            <h3 className="text-sm font-medium text-slate-900">Our address</h3>
            <p className="mt-2 text-slate-700">ShowTimeBro (Head Office) — Indore, Madhya Pradesh, India</p>
            <p className="mt-1 text-xs text-slate-500">(Add full street address here if you want it displayed)</p>

            {/* If you want an embedded map, replace the placeholder below with your Google Maps iframe */}
            <div className="mt-4 w-full h-48 bg-slate-100 rounded-md flex items-center justify-center text-slate-400 text-sm">
              Map placeholder — add Google Maps iframe here if required
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}
